import CryptoJS from "crypto-js";

export function encodeScript(str) {
    var encoded = "";
    str = btoa(str);
    str = btoa(str);
    for (var i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ 10; // bitwise XOR with any number, e.g. 123
        encoded = encoded + String.fromCharCode(b);
    }
    encoded = btoa(encoded);
    return encoded;
}
export function encryptJS(text, passKey) {
    var CryptoJS = require("crypto-js");
    var encrypted = CryptoJS.AES.encrypt(text, passKey).toString();
    return encrypted;
}

export function decryptJS(text, passKey) {
    var CryptoJS = require("crypto-js");
    var decrypted = CryptoJS.AES.decrypt(text, passKey).toString(CryptoJS.enc.Utf8);
    return decrypted;
}
/////////////////////////////
////////////////////////////////
/////mã hóa du liệu object khi fetch len luu vao localStorage

//const SECRET_KEY = "jH@05GzMcT$6!"; // 🔑 Khóa bí mật (KHÔNG chia sẻ)
const SECRET_KEY = global.config.key.encrypt;

/// 🔐 **Mã hóa JSON trước khi lưu vào localStorage**
export const encryptData = (data) => {
    try {
        const jsonData = JSON.stringify(data); // Chuyển JSON thành chuỗi
        return CryptoJS.AES.encrypt(jsonData, SECRET_KEY).toString();
    } catch (error) {
        //console.error("❌ Lỗi khi mã hóa:", error);
        return null;
    }
};

/// 🔓 **Giải mã JSON từ localStorage**
export const decryptData = (cipherText) => {
    try {
        const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
        const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(decryptedText); // Chuyển chuỗi thành JSON
    } catch (error) {
        //console.error("❌ Lỗi khi giải mã:", error);
        return "null";
    }
};

/// 💾 **Lưu vào localStorage**
export const saveToStorage = (key, value) => {
    const encryptedValue = encryptData(value);
    if (encryptedValue) {
        localStorage.setItem(key, encryptedValue);
        //console.log(`✅ Dữ liệu đã mã hóa và lưu: ${key}`);
    }
};

/// 🔍 **Lấy từ localStorage**
export const getFromStorage = (key) => {
    const encryptedValue = localStorage.getItem(key);
    if (!encryptedValue) return "null";
    return decryptData(encryptedValue);
};

///Call api to server
const API_BASE_URL = global.config.url.api; // sửa lại nếu khác

export async function fetchWithAuth(url, options = {}, retry = true) {
    const userStr = window.getFromStorage("user-info");
    if (userStr === "null") window.location.href = "/logout";

    const users = JSON.parse(userStr);
    const accessToken = users.token;

    // Gán method mặc định nếu chưa có
    options.method = options.method || "GET";
    // Gộp headers, nhưng KHÔNG ép Content-Type nếu body là FormData
    const isFormData = options.body instanceof FormData;

    // Thêm Authorization header
    options.headers = {
        ...(options.headers || {}),
        "user-id": users.id,
        Authorization: `Bearer ${accessToken}`,
        ...(isFormData ? {} : { "Content-Type": "application/json" }),
    };

    const response = await fetch(API_BASE_URL + url, options);

    if (response.status === 401 && retry) {
        console.warn("Token hết hạn hoặc sai thiết bị");
        //window.location.href = "/logout";
    }

    return response;
}
//////////MA HOA VA GIA MA CO KEY BAO VE
export const encrypt_js = (data, key) => {
    // Hash key thành 32 byte (WordArray)
    var parsedKey = CryptoJS.SHA256(key);

    // Tạo IV ngẫu nhiên 16 byte
    var iv = CryptoJS.lib.WordArray.random(16);

    // Mã hóa dữ liệu với AES-256-CBC
    var encrypted = CryptoJS.AES.encrypt(data, parsedKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // Kết hợp IV và ciphertext, mã hóa base64
    return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
};

export const decrypt_js = (encrypted_data, key) => {
    // Hash key thành 32 byte
    var parsedKey = CryptoJS.SHA256(key);

    // Giải mã base64 thành WordArray
    var data = CryptoJS.enc.Base64.parse(encrypted_data);

    // Kiểm tra độ dài dữ liệu
    if (data.sigBytes < 16) {
        return false; // Dữ liệu quá ngắn
    }

    // Tách IV (16 byte đầu, tức 4 words)
    var iv = CryptoJS.lib.WordArray.create(data.words.slice(0, 4), 16);

    // Ciphertext còn lại
    var ciphertext = CryptoJS.lib.WordArray.create(data.words.slice(4), data.sigBytes - 16);

    // Giải mã
    var decrypted = CryptoJS.AES.decrypt({ ciphertext: ciphertext }, parsedKey, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    // Trả về chuỗi UTF-8, hoặc false nếu giải mã thất bại
    try {
        return decrypted.toString(CryptoJS.enc.Utf8) || false;
    } catch (e) {
        return false;
    }
};

window.encodeScript = encodeScript;
window.encryptJS = encryptJS;
window.decryptJS = decryptJS;
window.saveToStorage = saveToStorage;
window.getFromStorage = getFromStorage;
window.fetchWithAuth = fetchWithAuth;
window.encrypt_js = encrypt_js;
window.decrypt_js = decrypt_js;

// // 🛠 **Ví dụ sử dụng**
// const userData = {
//     id: 123,
//     name: "Nguyễn Văn A",
//     email: "nguyenvana@example.com",
//     roles: ["admin", "editor"],
// };

// saveToStorage("user_data", userData); // 🔥 Lưu dữ liệu đã mã hóa

// const retrievedData = getFromStorage("user_data"); // 🔥 Lấy và giải mã dữ liệu
// console.log("🔓 Dữ liệu sau khi giải mã:", retrievedData);
